import React, { useState, useRef } from 'react';
import { Grid, Box, Button, Paper, Stack, Typography } from '@mui/material';
import { Add, CurrencyRupee } from '@mui/icons-material';
import { FaHandHolding } from 'react-icons/fa';
import '../../App.css';
import GratuityConfigurationTable from '../table-data/GratuityConfigurationTable';
import AddGratuityConfigurationForm from './AddGratuityConfigurationForm';
import Popup from '../Popup';
import Notification from '../Notification';

function Gratuity_Configuration() {
  const [openPopup, setOpenPopup] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });
  const tableRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleCloseModal = () => {
    setOpenPopup(false);
  };

  const handleRefresh = () => {
    tableRef.current?.refreshTable?.();
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', margin: '10px', padding: '50px', fontWeight: '500px' }}>
      <Paper elevation={5} sx={{ width: '60.5%', maxWidth: '1400px' }}>
        <Grid className="form-title" style={{ marginBottom: '-60px' }} container spacing={2}>
          <Grid item>
            <Typography variant="h5" sx={{ textAlign: 'center', margin: 5 }}>
              Gratuity Configuration
            </Typography>
          </Grid>
          <Grid item>
            <Box sx={{ position: 'relative', width: 42, height: 42, marginLeft: '-50px', display: 'inline-flex' }}>
              <FaHandHolding size={30} style={{ position: 'absolute', left: 2, bottom: 4 }} />
              <CurrencyRupee sx={{ fontSize: 18, position: 'absolute', right: 2, top: 2 }} />
            </Box>
          </Grid>
        </Grid>
        <form autoComplete="off" onSubmit={handleSubmit}>
          <Stack spacing={2} sx={{ margin: '33px' }}>
            <Stack display="flex" sx={{ alignItems: 'flex-end', marginRight: '30px' }}>
              <Button
                style={{ width: '220px', marginRight: '60px' }}
                className="form-btn"
                variant="outlined"
                color="success"
                onClick={() => setOpenPopup(true)}
                startIcon={<Add sx={{ width: '24px', height: '24px' }} />}
                sx={{ whiteSpace: 'nowrap', textTransform: 'none' }}
              >
                Add Gratuity Config
              </Button>
            </Stack>
            <GratuityConfigurationTable ref={tableRef} refreshKey={refreshKey} onNotify={setNotify} />
          </Stack>
        </form>

        <Popup title="Add Gratuity Configuration" openPopup={openPopup} setOpenPopup={setOpenPopup}>
          <AddGratuityConfigurationForm
            onCloseModal={handleCloseModal}
            setOpenPopup={setOpenPopup}
            onRefresh={handleRefresh}
            onNotify={setNotify}
          />
        </Popup>
      </Paper>
      <Notification notify={notify} setNotify={setNotify} />
    </Box>
  );
}

export default Gratuity_Configuration;
